
import {useInvestDialog} from "@/contexts/InvestDialogProvider";
import {useEffect, useState} from "react";
import * as Yup from "yup";
import {apiAddInvestor} from "@/services/HomeService.ts";
import {FormContainer, FormItem} from '@/components/ui/Form/index';
import {Field, Form, Formik} from 'formik'
import {Button} from "@/components/ui/Button/index";
import Input from "@/components/ui/Input/index";

type InvestorFormSchema = {
  name: string
  email: string
}

const InvestDialog = () => {
  const {setShowDialog, isShow} = useInvestDialog()
  
  const [isAdded, setIsAdded] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  
  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Please enter the shred name'),
    email: Yup.string().email('Invalid email').required('Please enter your email'),
  })
  
  useEffect(() => {
    setIsAdded(false)
    setErrorMessage('')
  }, [isShow]);
  const onSubmit = async (
    values: InvestorFormSchema,
    setSubmitting: (isSubmitting: boolean) => void
  ) => {
    setSubmitting(true)
    
    try {
      const response = await apiAddInvestor(values)
      if (response.status === 201) {
        setIsAdded(true)
      }
    } catch (errors: any) {
      setIsAdded(true)
      
      if (errors.response.status === 409) {
        setErrorMessage(errors.response.data.message)
      } else {
        setErrorMessage(errors.response.data.message)
      }
    } finally {
      setSubmitting(false)
    }
  }
  
  return (
    <>
      {isShow && (
        <div
          className="fixed h-screen w-screen top-0 right-0 left-0 bottom-0 bg-black flex justify-center items-center bg-opacity-60"
          onClick={(_e) => setShowDialog(false)}
        >
          <div
            className="w-[400px] rounded-lg bg-[#f5f4ea] p-5"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="text-xl font-bold text-black mb-5">Become an Investor</h3>
            {isAdded ? (
              <>
                {errorMessage ? (
                  <p className="text-red-600">{errorMessage}</p>
                ) : (
                  <p>
                    Thank you for investing in SHREDS. We will get back to you soon
                    as we can.
                  </p>
                )}
              </>
            ) : (
              <div>
                <Formik
                  initialValues={{name: '', email: ''}}
                  validationSchema={validationSchema}
                  onSubmit={(values, {setSubmitting}) => {
                    onSubmit(values, setSubmitting)
                  }}
                >
                  {({touched, errors, isSubmitting}) => (
                    <Form>
                      <FormContainer>
                        <FormItem
                          labelClass="text-xl text-[#6F6AF8] font-medium"
                          invalid={
                            (errors.name && touched.name) as boolean
                          }
                          htmlFor='name'
                          errorMessage={errors.name}
                        >
                          <Field
                            type="text"
                            autoComplete="off"
                            name="name"
                            placeholder="Enter your name"
                            className="border-[.5px] border-black rounded-xl px-2 py-2 mb-1 w-full"
                            component={Input}
                          />
                        </FormItem>
                        
                        <FormItem
                          labelClass="text-xl text-[#6F6AF8] font-medium"
                          invalid={
                            (errors.email && touched.email) as boolean
                          }
                          htmlFor='mail'
                          errorMessage={errors.email}
                        >
                          <Field
                            type="text"
                            autoComplete="off"
                            name="email"
                            placeholder="Enter your email address"
                            className="border-[.5px] border-black rounded-xl px-2 py-2 mb-1 w-full"
                            component={Input}
                          />
                        </FormItem>
                        
                        <div className="mb-2 text-right">
                          <Button
                            loading={isSubmitting}
                            block
                            variant='solid'
                            shape='circle'
                            className="bg-[#1450C4] hover:bg-[#1450C4] rounded-full text-lg font-bold">
                            {isSubmitting ? 'Sending...' : 'Send request'}
                          </Button>
                        </div>
                      </FormContainer>
                    </Form>
                  )}
                </Formik>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default InvestDialog;